import { render, staticRenderFns } from "./OurLA.vue?vue&type=template&id=0198639c&scoped=true&"
import script from "./OurLA.vue?vue&type=script&lang=js&"
export * from "./OurLA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198639c",
  null
  
)

export default component.exports